import { render, staticRenderFns } from "./ActionDropdown.vue?vue&type=template&id=124d2684&scoped=true&"
import script from "./ActionDropdown.vue?vue&type=script&lang=js&"
export * from "./ActionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ActionDropdown.vue?vue&type=style&index=0&id=124d2684&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d2684",
  null
  
)

export default component.exports